import React from 'react';

const DashboardHeader = ({ title, subtitle, refreshing, error, updatedAt }) => {
  let status = 'En attente des données';
  if (refreshing) status = 'Actualisation…';
  else if (error) status = error;
  else if (updatedAt) {
    status = `Actualisé à ${new Date(updatedAt).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`;
  }

  return (
    <header className="mx-auto mb-[22px] flex max-w-[1480px] flex-wrap items-center justify-between gap-4">
      <div>
        <h1 className="text-[28px] font-semibold leading-tight tracking-[-0.6px]">{title}</h1>
        <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
      </div>
      <span className="sr-only" role="status">
        {status}
      </span>
    </header>
  );
};
export default DashboardHeader;
